/**
 * #toast.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
export var ToastAppearance;
(function (ToastAppearance) {
    ToastAppearance[ToastAppearance["NEUTRAL"] = 0] = "NEUTRAL";
    ToastAppearance[ToastAppearance["SUCCESS"] = 1] = "SUCCESS";
    ToastAppearance[ToastAppearance["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ToastAppearance || (ToastAppearance = {}));
export function toastAppearanceFromJSON(object) {
    switch (object) {
        case 0:
        case "NEUTRAL":
            return ToastAppearance.NEUTRAL;
        case 1:
        case "SUCCESS":
            return ToastAppearance.SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ToastAppearance.UNRECOGNIZED;
    }
}
export function toastAppearanceToJSON(object) {
    switch (object) {
        case ToastAppearance.NEUTRAL:
            return 0;
        case ToastAppearance.SUCCESS:
            return 1;
        case ToastAppearance.UNRECOGNIZED:
        default:
            return -1;
    }
}
function createBaseToastLeadingElement() {
    return { icon: undefined, emoji: undefined, avatar: undefined };
}
export const ToastLeadingElement = {
    $type: "devvit.ui.toast.ToastLeadingElement",
    encode(message, writer = _m0.Writer.create()) {
        if (message.icon !== undefined) {
            writer.uint32(10).string(message.icon);
        }
        if (message.emoji !== undefined) {
            writer.uint32(18).string(message.emoji);
        }
        if (message.avatar !== undefined) {
            writer.uint32(26).string(message.avatar);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseToastLeadingElement();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.icon = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.emoji = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.avatar = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            icon: isSet(object.icon) ? globalThis.String(object.icon) : undefined,
            emoji: isSet(object.emoji) ? globalThis.String(object.emoji) : undefined,
            avatar: isSet(object.avatar) ? globalThis.String(object.avatar) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.icon !== undefined) {
            obj.icon = message.icon;
        }
        if (message.emoji !== undefined) {
            obj.emoji = message.emoji;
        }
        if (message.avatar !== undefined) {
            obj.avatar = message.avatar;
        }
        return obj;
    },
    create(base) {
        return ToastLeadingElement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseToastLeadingElement();
        message.icon = object.icon ?? undefined;
        message.emoji = object.emoji ?? undefined;
        message.avatar = object.avatar ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(ToastLeadingElement.$type, ToastLeadingElement);
function createBaseToastTrailingElement() {
    return { label: undefined, icon: undefined };
}
export const ToastTrailingElement = {
    $type: "devvit.ui.toast.ToastTrailingElement",
    encode(message, writer = _m0.Writer.create()) {
        if (message.label !== undefined) {
            writer.uint32(10).string(message.label);
        }
        if (message.icon !== undefined) {
            writer.uint32(18).string(message.icon);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseToastTrailingElement();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.icon = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            label: isSet(object.label) ? globalThis.String(object.label) : undefined,
            icon: isSet(object.icon) ? globalThis.String(object.icon) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.label !== undefined) {
            obj.label = message.label;
        }
        if (message.icon !== undefined) {
            obj.icon = message.icon;
        }
        return obj;
    },
    create(base) {
        return ToastTrailingElement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseToastTrailingElement();
        message.label = object.label ?? undefined;
        message.icon = object.icon ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(ToastTrailingElement.$type, ToastTrailingElement);
function createBaseToast() {
    return { text: "", appearance: undefined, leadingElement: undefined, trailingElement: undefined };
}
export const Toast = {
    $type: "devvit.ui.toast.Toast",
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        if (message.appearance !== undefined) {
            writer.uint32(16).int32(message.appearance);
        }
        if (message.leadingElement !== undefined) {
            ToastLeadingElement.encode(message.leadingElement, writer.uint32(26).fork()).ldelim();
        }
        if (message.trailingElement !== undefined) {
            ToastTrailingElement.encode(message.trailingElement, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseToast();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.appearance = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.leadingElement = ToastLeadingElement.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.trailingElement = ToastTrailingElement.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            appearance: isSet(object.appearance) ? toastAppearanceFromJSON(object.appearance) : undefined,
            leadingElement: isSet(object.leadingElement) ? ToastLeadingElement.fromJSON(object.leadingElement) : undefined,
            trailingElement: isSet(object.trailingElement)
                ? ToastTrailingElement.fromJSON(object.trailingElement)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.appearance !== undefined) {
            obj.appearance = toastAppearanceToJSON(message.appearance);
        }
        if (message.leadingElement !== undefined) {
            obj.leadingElement = ToastLeadingElement.toJSON(message.leadingElement);
        }
        if (message.trailingElement !== undefined) {
            obj.trailingElement = ToastTrailingElement.toJSON(message.trailingElement);
        }
        return obj;
    },
    create(base) {
        return Toast.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseToast();
        message.text = object.text ?? "";
        message.appearance = object.appearance ?? undefined;
        message.leadingElement = (object.leadingElement !== undefined && object.leadingElement !== null)
            ? ToastLeadingElement.fromPartial(object.leadingElement)
            : undefined;
        message.trailingElement = (object.trailingElement !== undefined && object.trailingElement !== null)
            ? ToastTrailingElement.fromPartial(object.trailingElement)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(Toast.$type, Toast);
function isSet(value) {
    return value !== null && value !== undefined;
}
